import { required, validUuid } from "../../../utils/validationRules";
import Lookup from "../Lookup";

const HTTP_NOT_FOUND = 404;

const RELATION_PARAMS = {
  includeRelations: 'binding',
  expandRelations: 'binding',
};

export default class EmbeddedDeviceLookup extends Lookup {
  attrDisplayId = 'au.devices.deviceIdOrEsn';

  attrPlaceholderId = 'au.devices.lookupEmbeddedDevicePlaceholder';

  embedded = true;

  validate() {
    const { inputStr } = this.state;
    // required
    let validationError = required(inputStr);
    let idError = {};

    if (!validationError) {
      // is not uuid
      idError = validUuid(inputStr);
    }

    this.setState(prevState => ({
      showError: prevState.submitted && Boolean(validationError),
      error: {
        ...validationError,
        fieldDisplayId: this.attrDisplayId
      },
      isUuid: !idError
    }));

    return validationError;
  }

  extractItems(response) {
    const data = response?.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
  }

  lookup() {
    const { endpoint } = this.props;
    const { isUuid, inputStr } = this.state;

    if (isUuid) {
      return endpoint.get(inputStr, RELATION_PARAMS);
    }

    // check getByUniqueProperty first, then fall back to list by serial
    return endpoint
      .getByUniqueProperty({
        uniquePropertyValue: inputStr,
        ...RELATION_PARAMS,
      })
      .catch((err) => {
        // only fall back on "not found"; other errors go to onError
        if (err?.status !== HTTP_NOT_FOUND) {
          return Promise.reject(err);
        }
        return this.listBySerial(inputStr);
      });
  }

  listBySerial(serial) {
    const { endpoint } = this.props;

    return endpoint
      .list({ properties: `serial:${serial}`, ...RELATION_PARAMS })
      .then((response) => {
        const items = this.extractItems(response);

        if (items.length === 1) {
          // single-entity shape so the base onSuccess can redirect
          return { ...response, data: items[0] };
        }
        return Promise.reject({ status: HTTP_NOT_FOUND });
      });
  }
}
